import { useCallback, useEffect, useMemo, useState } from "react";
import { presalesApi } from "../api/presalesApi";

export function usePresalesData() {
  const [leads, setLeads] = useState([]);
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ scope: "open", owner_id: "", q: "" });

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.scope === "open") params.scope = "open";
      if (filters.owner_id) params.owner_id = filters.owner_id;

      const [leadsData, statsData] = await Promise.all([
        presalesApi.getLeads(params),
        presalesApi.getStats(),
      ]);
      setLeads(Array.isArray(leadsData) ? leadsData : []);
      setStats(statsData || null);
    } catch {
      // keep previous data on error
    } finally {
      setLoading(false);
    }
  }, [filters.scope, filters.owner_id]);

  const fetchMeta = useCallback(async () => {
    try {
      const [usersData, productsData] = await Promise.all([
        presalesApi.listUsers(),
        presalesApi.listProducts(),
      ]);
      setUsers(Array.isArray(usersData) ? usersData : []);
      setProducts(Array.isArray(productsData) ? productsData : []);
    } catch {
      // non-critical
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  useEffect(() => {
    fetchMeta();
  }, [fetchMeta]);

  const filteredLeads = useMemo(() => {
    const q = filters.q.trim().toLowerCase();
    if (!q) return leads;
    return leads.filter((l) => {
      const hay = [
        l.lead_number,
        l.contact_name,
        l.company_name,
        l.company_type,
        l.location,
        l.owner_name,
        l.product_name,
        l.next_action,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return hay.includes(q);
    });
  }, [leads, filters.q]);

  return {
    leads: filteredLeads,
    totalLeads: leads.length,
    stats,
    users,
    products,
    loading,
    filters,
    setFilters,
    refetch: fetchAll,
  };
}
